import { render, staticRenderFns } from "./SecurityCenter.vue?vue&type=template&id=727dc3e0&scoped=true"
import script from "./SecurityCenter.vue?vue&type=script&lang=js"
export * from "./SecurityCenter.vue?vue&type=script&lang=js"
import style0 from "./SecurityCenter.vue?vue&type=style&index=0&id=727dc3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727dc3e0",
  null
  
)

export default component.exports